import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { combineLatest, filter, from, map, take } from 'rxjs';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
	const router: Router = inject(Router);
	const auth0: Auth0Service = inject(Auth0Service);

	// Wait for Auth0 SDK to finish loading, then decide based on isAuthenticated
	return combineLatest([auth0.isLoading$, auth0.isAuthenticated$]).pipe(
		filter(([loading]) => !loading),
		take(1),
		switchMap(([_, isAuth]) => {
			if (!isAuth) {
				const appRedirect =
					typeof state.url === 'undefined' ||
					state.url === '/sign-out' ||
					state.url.includes('error')
						? undefined
						: state.url;

				return from(
					auth0.loginWithRedirect({
						appState: appRedirect
							? { target: appRedirect }
							: undefined,
					})
				).pipe(map(() => false));
			}
			return of(true);
		})
	);
};
